import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter008() {
  return <KbChapterPage slug="chapter-008" />;
}

(Chapter008 as unknown as { path: string }).path = "/theory-album/008";
